import Vue from "vue";
import { SchemeType, SchemeProgress } from "@foxone/api/src/models/defi";
import { ProductTypes } from "defi/constants";
import { GetterTree, MutationTree, ActionTree } from "vuex/types/index";

const state = () => {
  const schemes = ProductTypes.reduce((m, k) => (m[k] = []), {});
  return {
    ...schemes,
    activeIndex: 0,
    loading: false
  };
};

export type SchemesState = ReturnType<typeof state>;

const getters: GetterTree<SchemesState, {}> = {
  getSchemesByType(state) {
    return (type: SchemeType) => {
      return state[type];
    };
  }
};

const mutations: MutationTree<SchemesState> = {
  SET_SCHEMES(state, { data, type }) {
    const order = [
      SchemeProgress.OPENING,
      SchemeProgress.PRE_OPEN,
      SchemeProgress.FULL,
      SchemeProgress.RUNNING
    ];
    data.sort((a, b) => {
      const va = order.indexOf(a.progress);
      const vb = order.indexOf(b.progress);
      return va > vb ? 1 : va === vb ? 0 : -1;
    });
    Vue.set(state, type, data);
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_ACTIVE_INDEX(state, value) {
    state.activeIndex = value;
  }
};

const actions: ActionTree<SchemesState, {}> = {
  async loadSchemes({ commit }) {
    // const loadScheme = async (type: SchemeType) => {
    //   const actions = this.$api.defi.getActionsBySchemeType(type);
    //   const schemes = await actions.getSchemes();
    //   commit("SET_SCHEMES", { data: schemes, type });
    // };
    // await Promise.all(ProductTypes.map(type => loadScheme(type)));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
